module.exports = __webpack_public_path__ + "static/analyze-session-recordings-e729fa1f3b6a8c648be41e8b4bcbaa6c.png";